import React from 'react'
import { useModal } from '@mprolab/uikit'
import ProviderActionModal from './ProviderActionModal'
import { ProviderActionModalProps } from './index.types'
import { providerActionModalStore } from './ProviderActionModalStore'

export interface ReturnType {
  onPresentProviderActionModal: (currentChainId?: number, chainIdToSwitchTo?: number) => void
  onDismissProviderActionModal: () => void
}

const useProviderActionModal = (props?: ProviderActionModalProps): ReturnType => {
  const [onPresent, onDismissProviderActionModal] = useModal(<ProviderActionModal {...props} />, false)

  const onPresentProviderActionModal = (currentChainId?: number, chainIdToSwitchTo?: number) => {
    providerActionModalStore.setChains({
      currentChainId,
      chainIdToSwitchTo
    })
    onPresent()
  }

  return { onPresentProviderActionModal, onDismissProviderActionModal }
}

export default useProviderActionModal
